(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !window.DesignMode) return;
  try {
    
 $('form#ContactForm .btn').click(function(e){
    var $formId = $(this).parents("form");
    var formAction = $formId.attr("action");
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    var phoneReg = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    var $error = $("<span class=\"error\"></span>");
    $("span.error").remove();
    $(".input-holder").removeClass("error");
    $(".required",$formId).each(function(){
       var inputVal = $.trim($(this).val());
      var fieldtitle = $(this).attr("title");
      var fieldname=$(this).attr("name");
      var $parentTag = $(this).parent();
      if(inputVal == "" || inputVal=="-1"){
          if($(this).hasClass("sel") == true){
           $parentTag.addClass("error").append($error.clone().text("Please select your "+fieldtitle+"."));
          }
          else{
           $parentTag.addClass("error").append($error.clone().text("Please enter your "+fieldtitle+"."));
          }

         $(this).focus();
        return false;
       }
       if($(this).hasClass("email") == true){
         if(!emailReg.test(inputVal)){
           $parentTag.addClass("error").append($error.clone().text("Sorry, you have entered an invalid Email Address."));
           $(this).focus();
          return false;
        }
      }
      if($(this).hasClass("tel") == true){
         if(!phoneReg.test(inputVal)){
          $parentTag.addClass("error").append($error.clone().text("Phone number seems invalid."));
          $(this).focus();
          return false;
         }
       }
     });
     if ($("span.error").length > 0) {
      $("span.error").each(function(){
        var distance = 5;
         var width = $(this).outerWidth();
         var start = width + distance;
        $(this).show().css({
           display: "block",
           opacity: 0
         }).animate({
          opacity: 1
         }, "slow");
      }); 
       e.preventDefault();
     } else {
      var fname=$('#ContactForm-name').val();
      var email=$('#ContactForm-email').val();
      var phone=$('#ContactForm-phone').val();
      //var subject=$('#contactFormSubject').val();
      var comments=$('#ContactForm-body').val();

      var result='{"fname":"'+fname+'", "email":"'+email+'", "phone":"'+phone+'", "comments":"'+comments+'"}';
      sessionStorage.setItem('submitted_data', result);
     
    }
     // e.preventDefault();
   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('form#create_customer');
  const submitButton = form.querySelector('button');
  const dobInput = document.getElementById('dob');
  const noteInput = document.getElementById('customer_note');
  const dobError = document.getElementById('dob-error');

  submitButton.addEventListener('click', function(event) {
    dobError.style.display = 'none'; // Reset error

    const dobValue = dobInput.value;
    if (!dobValue) {
      event.preventDefault();
      dobError.innerText = 'Date of Birth cannot be blank.';
      dobError.style.display = 'block';
      dobInput.classList.add('input--error');
    }
    else{
       noteInput.value = 'DOB: ' + dobValue;
    }

    const dob = new Date(dobValue);
    const today = new Date();
    // Clear time part for today
    today.setHours(0, 0, 0, 0);

    if (dob > today) {
      event.preventDefault();
      dobError.innerText = 'Date of Birth cannot be in the future.';
      dobError.style.display = 'block';
      dobInput.classList.add('input--error'); // Optional: Add error class for styling
    } else {
      dobInput.classList.remove('input--error');
    }
  });

  flatpickr("#dob", {
      dateFormat: "Y-m-d",  
      maxDate: "today",    
      allowInput: true
    });
    const dobLabel = document.getElementById("dob-label");

    dobInput.addEventListener("change", () => {
      if (dobInput.value) {
        dobLabel.style.display = "none";
      } else {
        dobLabel.style.display = "inline";
      }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thank-you"]) return;
  try {
    
  var submitted_data = sessionStorage.getItem('submitted_data');
    if (submitted_data) {
      function getCookie(name) {
          var value = "; " + document.cookie;
          var parts = value.split("; " + name + "=");
          if (parts.length == 2) return parts.pop().split(";").shift();
        }
         var obj = JSON.parse(submitted_data);
		 var ad_fname = obj.fname;
         var ad_email = obj.email;
         var ad_phone = obj.phone;
         var ad_comments = obj.comments;
		 if (ad_fname !== "" && ad_email !== "" && ad_phone !== ""){
			$.ajax({
				url: 'https://www.adluge.com/clientcenter/api/addlead-callback.php',
				jsonp: "callback",
        		dataType: "jsonp",
				data:{
					fname		: ad_fname,
					client_code  : "fbetpjn2xyzq9b7",
					email 		: ad_email,
					phone		: ad_phone,
					comments    : ad_comments,
					referer 		: window.location.href,
					lead_sessionid	: getCookie("_adl_id.AL_2285"),
					gclid    : getCookie("gclid")
				},
				success: function (data){
					sessionStorage.removeItem("submitted_data");
				}, 
			});
		 }
    }

  } catch(e) { console.error(e); }
})();
})();
